import JSZip from "jszip";
import FileSaver from "file-saver";
import { HeadCell } from "src/components/common/SortableTableHead";
import { CsvBuilder } from "filefy";

export interface FileStructure {
    [key: string]: FileStructure | string[]
}

export const downloadImagesAsZip = async(folderName: string,
                                  subFiles: FileStructure | string[],
                                  parentZip?: JSZip,
                                  promiseList?: Promise<void>[]) => {
    let isTopLevel: boolean = parentZip === undefined;

    let currZip: JSZip;
    if (isTopLevel) {
        parentZip = new JSZip();
        currZip = parentZip;
        promiseList = [];
    }
    else {
        currZip = parentZip!.folder(folderName)!;
    }

    if (Array.isArray(subFiles)) {
        subFiles.map(async (signedUrl: string) => {
            const filename = getBinaryFileNameFromSignedUrl(signedUrl);
            // As the files are retrieved asynchronously, create a promise for each file to be retrieved
            // and resolve the promise after the file retrieval is complete
            promiseList!.push(new Promise(resolve => {
                fetch(signedUrl, {
                    method: "GET",
                    headers: {
                        // This is required to avoid transient failures in Chrome while retrieving files
                        "Cache-Control": "no-cache"
                    }
                }).then(response => response.blob()).then(blob => {
                    // Add retrieved files to respective capture folder
                    currZip.file(filename, blob);
                    resolve();
                })
            }));
        });
    }
    else {
        Object.keys(subFiles).map((subFolderName: string) => {
            let nextLevel = subFiles[subFolderName];
            downloadImagesAsZip(subFolderName, nextLevel, currZip, promiseList);
        });
    }

    if (isTopLevel) {
        // Create the zip file with captures only after all the promises are resolved
        // to ensure that all files are retrieved and available for zip creation.
        await Promise.all(promiseList!).then(() => parentZip!.generateAsync({type: "blob"}).then(blob => {
            FileSaver.saveAs(blob, folderName);
        }));
    }
}

export const downloadTableDataAsCsvWithName = (dataRows: any[][], csvFileName: string, columnHeads: Array<HeadCell>) => {
    const builder = new CsvBuilder(csvFileName);
    builder
        .setColumns(columnHeads.map((columnHead) => columnHead.label))
        .addRows(dataRows)
        .exportFile();
};

const getBinaryFileNameFromSignedUrl = (signedUrl: string): string => {
    const baseUrl = signedUrl.split('?')[0];
    return baseUrl.substring(baseUrl.lastIndexOf('/') + 1);
};
